




























import { Vue, Component } from "vue-property-decorator";
import { currentUserStore } from "@/store/typed";
import { User } from "../models";
import ClickOutside from "@/directives/ClickOutside";
import { mixins } from "vue-class-component";
import { authStore } from "@/store/typed";
import OauthMixin from "@/mixins/http/OauthMixin";
import { AUTHORIZER_URL } from "@/utils/Constants";

@Component({ components: {}, directives: { ClickOutside } })
export default class UserTopbarDropdown extends mixins(OauthMixin) {
  private open = false;

  get currentUser(): User | undefined {
    return currentUserStore.user;
  }

  get role() {
    return User.roles.find((o) => o.id === this.currentUser?.role)?.name || "";
  }

  async onLogout() {
    await this.logout();
    this.$router.push({ name: "login" });
  }

  protected close() {
    this.open = false;
  }
}
